import { useMemo } from 'react';
import { Avatar, FlexRow, Text } from '@epam/promo';
import { useUserStore } from 'store/user';
import { REVOKED_STATUS } from 'models/user.model';
import { ItemOneOf } from 'interfaces';
import { dateWithTimeToString } from '../../../hooks/helpers/date-time-helper';

export const FormHeaderInfo = ({ draft }: { draft: ItemOneOf }) => {
  const { user } = useUserStore();

  const author = useMemo(() => draft.author ?? user, [draft.author, user]);

  const userName = useMemo(() => {
    const statusString = author?.status === REVOKED_STATUS ? '(INACTIVE)' : '';

    return [author?.firstName, author?.lastName, statusString]
      .filter((v) => v)
      .join(' ');
  }, [author]);

  return (
    <FlexRow>
      <FlexRow columnGap="6">
        <Text color="gray60" fontSize="12" lineHeight="18">
          Last edited by
        </Text>
        <Text color="gray60" fontSize="12" lineHeight="18">
          {dateWithTimeToString(draft.updatedAt)}
        </Text>
        <Avatar alt={author?.id} img={author?.avatar ?? null} size="24" />
        <Text color="gray60" fontSize="12" lineHeight="18">
          {userName}
        </Text>
      </FlexRow>
    </FlexRow>
  );
};
